import {
  Box, Card,
  CardContent,
  FormControl, FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import LogoBlock from "../components/LogoBlock";
import React, {FC} from "react";
import {FormikErrors, FormikTouched} from "formik";

type PropsType = {
  handleChange: {(e: React.ChangeEvent<any>): void, <T_1=string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : ((e: (string | React.ChangeEvent<any>)) => void)}
  errors: FormikErrors<any>
  touched: FormikTouched<any>
  values: any
  typeOptions: {value: string, display_name: string}[]
  employeesOptions: {value: string, display_name: string}[]
  setFieldValue: (field: string, value: any) => void
}

const CompanyInformationSection: FC<PropsType> = ({
  values,
  touched,
  errors,
  handleChange,
  typeOptions,
  employeesOptions,
  setFieldValue,
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" style={{ marginBottom: "20px" }}>
          1. Company information
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Box mb={3}>
              <TextField
                id={'name'} name={'name'} label={'Name'}
                value={values.name}
                onChange={handleChange}
                helperText={!!errors.name && !!touched.name && errors.name}
                error={!!errors.name && !!touched.name}
                fullWidth
              />
            </Box>
            <Box mb={3}>
              <TextField
                id={'email'} name={'email'} label={'Email'}
                value={values.email}
                onChange={handleChange}
                helperText={!!errors.email && !!touched.email && errors.email}
                error={!!errors.email && !!touched.email}
                fullWidth
              />
            </Box>
            <Box mb={3}>
              <TextField
                id={'registration_number'} name={'registration_number'} label={'Registration number'}
                value={values.registration_number}
                onChange={handleChange}
                helperText={!!errors.registration_number && !!touched.registration_number && errors.registration_number}
                error={!!errors.registration_number && !!touched.registration_number}
                fullWidth
              />
            </Box>
            <Box mb={3}>
              <FormControl
                error={!!errors.nr_employees && !!touched.nr_employees}
                fullWidth
              >
                <InputLabel id="nr_employees">Nr employees</InputLabel>
                <Select
                  id={'nr_employees'} name={'nr_employees'} label={'Nr employees'}
                  value={values.nr_employees}
                  onChange={handleChange}
                  fullWidth
                >
                  {employeesOptions.map((i, index) => (
                    <MenuItem key={index} value={i.value}>{i.display_name}</MenuItem>
                  ))}
                </Select>
                {!!errors.nr_employees && !!touched.nr_employees && (
                  <FormHelperText error>{errors.nr_employees}</FormHelperText>
                )}
              </FormControl>
            </Box>
            <Box mb={3}>
              <TextField
                id={'hubspot_company_id'} name={'hubspot_company_id'} label={'Hubspot company id'}
                value={values.hubspot_company_id}
                onChange={handleChange}
                helperText={!!errors.hubspot_company_id && !!touched.hubspot_company_id && errors.hubspot_company_id}
                error={!!errors.hubspot_company_id && !!touched.hubspot_company_id}
                fullWidth
              />
            </Box>
            <Box mb={3}>
              <FormControl fullWidth>
                <InputLabel id="type">Type</InputLabel>
                <Select
                  id={'type'} name={'type'} label={'Type'}
                  value={values.type}
                  onChange={handleChange}
                  fullWidth
                >

                  {typeOptions.map((i, index) => (
                    <MenuItem key={index} value={i.value}>{i.display_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              width={'100%'}
              height={'100%'}
            >
              <LogoBlock
                value={values.logo}
                onSetFieldValue={setFieldValue}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CompanyInformationSection